import { cva } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import React from "react";
import { cn } from "../../lib/utils";

type Size = "small" | "medium" | "large";

const variant = cva("flex flex-col flex-1", {
  variants: {
    size: {
      small: "size-8",
      medium: "size-12",
      large: "size-16",
    },
  },
});

export const Loader = React.forwardRef<
  HTMLDivElement,
  {
    className?: string;
    size?: Size;
    children?: React.ReactNode;
    isLoading: boolean;
  }
>(({ className, children, isLoading, size = "medium" }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "flex flex-col flex-1",
        className,
        isLoading && "items-center justify-center"
      )}
    >
      {isLoading ? (
        <Loader2 className={cn("size-4 animate-spin", variant({ size }))} />
      ) : (
        children
      )}
    </div>
  );
});

Loader.displayName = "Loader";
